import { FillsGraphDataByOrderIdRequestNormalizeBy } from 'communication/types/fillsGraph/FillsGraphDataByOrderIdRequest';
import {
    AppSettingsState,
    SymbologyValues,
} from 'app/store/appSettings/AppSettingsState';
import State from 'store/State';
import { selectFillsGraphConfiguration } from 'widgets/fillsGraph/store/configuration/selectors';
import FillsGraphByOrderIdOrSymQtyStreamRequest, {
    FillsGraphByOrderIdOrSymQtyStreamRequestCommon,
    FillsGraphPlBenchmarkType,
} from 'communication/types/fillsGraph/FillsGraphByOrderIdOrSymQtyStreamRequest';
import { PortfolioSelectionWrapper } from 'portfolio/PortfolioSelectionWrapper';
import { PnlBenchmark } from 'utils/PnL';
import {
    defaultFillsGraphConfiguration,
    FillsChartType,
    FillsGraphConfiguration,
} from 'widgets/fillsGraph/store/configuration/FillsGraphConfiguration';

export function buildFillsGraphRequest(
    orderIds: string[],
    portfolioSelection: PortfolioSelectionWrapper,
    indexSymbology: SymbologyValues,
    config: FillsGraphConfiguration
): FillsGraphByOrderIdOrSymQtyStreamRequest | undefined {
    const { symbology } = portfolioSelection;
    const {
        general: {
            displayExtendedHours: extendedHours,
            useSecondarySymbol,
            fallbackIndex: indexSym,
        },
        PnL: pnl,
    } = config;

    const pnlChartBenchmark = (
        pnl ?? defaultFillsGraphConfiguration[FillsChartType.PnL]
    ).pnlChartBenchmark;

    const common: FillsGraphByOrderIdOrSymQtyStreamRequestCommon = {
        indexSymbology,
        indexSym,
        extendedHours,
        useSecondarySymbol,
        normalizeBy: FillsGraphDataByOrderIdRequestNormalizeBy.ByArrival,
        includeStrategyParms: true,
        useIndividualOrderArrival:
            pnlChartBenchmark === PnlBenchmark.IndividualOrderArrival,
        benchmarkType:
            pnlChartBenchmark === PnlBenchmark.IndividualOrderArrival
                ? 'ARRIVAL'
                : (pnlChartBenchmark.toUpperCase() as FillsGraphPlBenchmarkType),
    };

    if (orderIds && orderIds.length > 0) {
        return {
            orderIds: orderIds.join(','),
            ...common,
        };
    }

    const { selectedSymbolQuantity } = portfolioSelection;

    if (selectedSymbolQuantity) {
        return {
            symbology,
            symQty: `${selectedSymbolQuantity.symbol},${selectedSymbolQuantity.qty}`,
            ...common,
        };
    }

    return undefined;
}

export function createFillsGraphRequest(
    orderIds: string[],
    portfolioSelection: PortfolioSelectionWrapper,
    widgetKey: string,
    appSettings: AppSettingsState,
    state: State
): FillsGraphByOrderIdOrSymQtyStreamRequest | undefined {
    const config = selectFillsGraphConfiguration(state, widgetKey);

    return buildFillsGraphRequest(
        orderIds,
        portfolioSelection,
        appSettings.symbology,
        config
    );
}
